import React from 'react';
import { Button, Grid, Row, Col } from 'react-bootstrap';

export default function FinalStep(props) {
  return (
    <React.Fragment>
      <h4>Account successfully added</h4>

      <Grid>
        <Row>
          <Col sm={4}></Col>
          <Col sm={4}>
            <Button bsStyle="primary" bsSize="large" onClick={props.onClose}>
              Close
            </Button>
          </Col>
          <Col sm={4}></Col>
        </Row>
      </Grid>
    </React.Fragment>
  );
}
